module.exports = __webpack_public_path__ + "img/pay_employee.35d6c338.png";